export class DeviceModel {
    id: string;
    busIdentifier: string;
    name: string;
    value: string;
    checked: boolean;
   constructor() { 
        this.value == "1" ? true : false;
   }
}


// WEBPACK FOOTER //
// ./src/app/models/device.model.ts